<section>
  <div class="page__title">
    <div class="page__title_container">
      <h2>
        {{ 'Processes' | translateWF: 'Processes' }}
      </h2>
      <div class="page__title_buttons">
        <p-button
          [icon]="showPreview() ? 'pi pi-pencil' : 'pi pi-eye'"
          [text]="true"
          [rounded]="true"
          severity="secondary"
          (click)="togglePreview()"
          [pTooltip]="showPreview() ? ('Edit' | translateWF: 'Edit') : ('Show_Preview' | translateWF: 'Show Preview')"
          tooltipPosition="top"
          styleClass="ml-2"
        />
      </div>
    </div>
  </div>

  <div class="preview-section" [class.hidden]="!showPreview()">
    <app-process-details-table [processes]="processesForTable()" />
  </div>

  <div [class.hidden]="showPreview()">
    @if (canEdit()) {
      <div class="add-process-section">
        <p-autoComplete
          class="cs-fill-width"
          [formControl]="processToAdd"
          #processSearch="cslServerSearch"
          [cslServerSearch]="fetchProcesses"
          [suggestions]="processSearch.results()"
          optionLabel="name.en"
          [placeholder]="'Search_Process' | translateWF: 'Search Process'"
          [dropdown]="true"
          [forceSelection]="true"
          [showClear]="true"
          (onSelect)="onProcessSelect($event)"
          appendTo="body"
        >
          <ng-template let-process pTemplate="item">
            {{ getProcessName(process) }}
          </ng-template>
        </p-autoComplete>
      </div>
    }

    @if (processes.length === 0) {
      <div class="empty-state">
        <p>
          {{ 'No_Processes_Added' | translateWF: 'No processes added yet' }}
        </p>
      </div>
    } @else {
      <div class="processes-list">
        @for (processControl of processes.controls; track processControl.value.processId; let i = $index) {
          @let process = processControl.value;
          <div class="process-card mb-4 p-4 bg-white rounded-md shadow-md">
            <div class="process-header">
              <h3>{{ getProcessName(process) }}</h3>
              @if (canEdit()) {
                <p-button icon="pi pi-trash" severity="danger" [text]="true" (click)="removeProcess(i)" />
              }
            </div>

            <div class="process-content">
              @if (process.additionalParameters && process.additionalParameters.length > 0) {
                <app-parameter-details-viewer [formControl]="getParametersControl(process)" [canEdit]="canEdit() && canEditParameters()" />
              }

              @if (process.itemDetails && process.itemDetails.length > 0) {
                <app-item-details-viewer
                  [itemDetailsFormGroups]="getItemDetailsFormGroupsForProcess(process)"
                  [inventoryTypeReference]="inventoryTypeReference()"
                  [canEdit]="canEdit() && canEditItems()"
                />
              }

              @if (process.stepIdsWithOrder && process.stepIdsWithOrder.length > 0) {
                <app-step-details-viewer
                  [formControl]="getStepsControl(process)"
                  [inventoryTypeReference]="inventoryTypeReference()"
                  [canEdit]="canEdit() && canEditSteps()"
                  [canEditItems]="true"
                  [canEditParameters]="true"
                />
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</section>
